const parseError = (error, detailed = false) => {
  const response = detailed ? error : error.message;
  return Promise.reject(response);
};

export default parseError;
